import React, { Component } from 'react';

export default class Loading extends Component {
    render() {
        return (
            <div
                style={{
                    width: this.props.width || '100%',
                    height: this.props.height || '100%',
                    position: 'relative'
                }}
            >
                <div
                    className={this.props.size === 'big' ? 'big-loader' : 'small-loader'}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Loading.js